import React, { useEffect, useState } from "react";
import Table from "../../components/table/Table";
import Inputs from "../../components/inputs/Inputs";
import MyDialog from "../../components/dialog/Dialog";
import MySpinner from "../../components/Spinner/spinner";
import validate from "validate.js";
import AppTabs from "../../components/appTabs/appTabs";
import { toast } from "react-toastify";
import moment from "moment";
import { getSchedulesList, postVisitSchedule, putVisitSchedule } from "../../api/visitSchedulesAPI";
import { getUserList } from "../../api/userAPI";
import { useDispatch } from "react-redux";
import { scheduleSchema, visitSchema } from "../../common/validators";
import { postVisit } from "../../api/visitsAPI";

const tableHead = [
    { label: "Planned Visit Date", name: "planed_visit_date" },
    { label: "Name", name: "customer_name" },
    { label: "Mobile", name: "customer_mobile" },
    { label: "Alternative Mobile", name: "alt_customer_mobile" },
    { label: "Birth", name: "dob" },
    { label: "Address", name: "address" },
    { label: "Actual Visit Date", name: "visit_date" },
    { label: "Status", name: "status" },
    "action",
  ];

const Schedules = () => {
    let [openForm, setOpenForm] = useState(false);
    let [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const [schedulesList, setSchedulesList] = useState([]);
    const [formValues, setFormValues] = useState({"visit_date": new Date()});
    const [visitFormValues, setVisitFormValues] = useState({"visit_date": new Date()});
    const [OfficersList, setOfficersList] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    let [hideSaveButton, setHideSaveButton] = useState(false);
    let [isView, setIsView] = useState(false);
    let [isVisit, setIsVisit] = useState(false);
    

     const dispatch = useDispatch();


     const loadSchedules = async () => {
        setIsLoading(true)
        let schedules = await getSchedulesList();
        setIsLoading(false)
        if(schedules.data){
       let arr = [];
        for (let index = 0; index < schedules.data.length; index++) {
         let element = schedules.data[index]; 
          element.planed_visit_date =  moment(element.planed_visit_date).format('YYYY-MM-DD');      
          element.visit_date =  moment(element.visit_date).format('YYYY-MM-DD');  
          element.dob =  moment(element?.dob).format('YYYY-MM-DD');  
          arr.push(element)    
        }
        setSchedulesList(arr)
        }
        return true
    }

    const loadOfficers = async () => {
        let officers = await getUserList();
        if(officers.data){
          let arr = [];
           for (let index = 0; index < officers.data.length; index++) {
            const element = officers.data[index];
            let obj = {value: element.id, label: element?.f_name+' '+element?.f_name+' '+element?.l_name}
            arr.push(obj)
           }
           setOfficersList(arr)
        }
        return true
      }

    useEffect(() => {
        loadSchedules()
      }, [dispatch]);

      useEffect(() => {
        if(selectedItem?.id && isVisit === false){
          loadOfficers()
          let newFormValues = {
            customer_id: selectedItem?.customer_id,
            attendant_id: selectedItem?.attendant_id,
            planed_visit_date: selectedItem?.planed_visit_date,
            visit_date: selectedItem?.visit_date,
            remarks: selectedItem?.remarks,
            id: selectedItem?.id,
            service_id: selectedItem?.service_id,
            pay_type: selectedItem?.pay_type
          }
          setFormValues(newFormValues)
        }

        if(selectedItem?.id && isVisit === true){
          let newFormValues = {
            customer_id: selectedItem?.customer_id,
            visit_date: selectedItem?.visit_date,
            scheduled_date: selectedItem?.planed_visit_date,
            //remarks: selectedItem?.remarks,
            schedule_id: selectedItem?.id,
            service_id: selectedItem?.service_id
          }
          setVisitFormValues(newFormValues)
        }
      }, [selectedItem]);

      const handleChange = (event) => {   
        //alert(JSON.stringify(event.target.value))
        setFormValues({
          ...formValues,
          [event.target.name]:
            event.target.type === "checkbox"
              ? event.target.checked
              : event.target.value,
        });
    
      };

      const handleChangeVisit = (event) => {   
        setVisitFormValues({
          ...visitFormValues,
          [event.target.name]:
            event.target.type === "checkbox"
              ? event.target.checked
              : event.target.value,
        });
    
      };

      const viewItem = (item) => {
        if (item) {    
          // setFormValues({})
          loadOfficers()
          setSelectedItem(item);
          setIsView(true)
          setIsVisit(false)
          setTimeout(() => {
            setOpenForm(true);
          }, 300);
        }
      };

      const editItem = (item) => {
        if (item) {    
          // setFormValues({})
          loadOfficers()
          setSelectedItem(item);
          setIsView(false)
          setIsVisit(false)
          setTimeout(() => {
            setOpenForm(true);
          }, 300);
        }
      };

      const markVisit = (item) => {
        if (item) {    
          setVisitFormValues({})
          setSelectedItem(item);
          setIsView(false)
          setIsVisit(true)
          setTimeout(() => {
            setOpenForm(true);
          }, 300);
        }
      };

      
    

      const formVisitSchedule = (schedule) => {
          return (
            <>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-6">
                  <Inputs
                    name="service_id"
                    size="small"
                    disabled={isView}
                    inputType="select"
                    value={formValues.service_id}
                    defaultValue={{value:'retail',label:'Retail'}}
                    label="Service Category"
                    listLabel="Service Category"
                    listValue="service_id"
                    list={[{value:1,label:'Physiotherapy'},{value:2,label:'Home Nursing'}]}
                    onChange={handleChange}
                    error={errors["service_id"] ? true : false}
                    helperText={errors["service_id"] ? errors.service_id[0] : null}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-6">
                  <Inputs
                    name="visit_date"
                    size="small"
                    disabled={isView}
                    label="Visit Date"
                    value={formValues.visit_date}
                    inputType="date"
                    onChange={(e) =>
                    handleChange({ target: { name: "visit_date", value: e } })}
                    error={errors["visit_date"] ? true : false}
                    helperText={errors["visit_date"] ? errors.visit_date[0] : null}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-6">
                  <Inputs
                    name="pay_type"
                    size="small"
                    disabled={isView}
                    inputType="select"
                    value={formValues.pay_type}
                    defaultValue={{value:'cash',label:'Cash'}}
                    label="Pay Type"
                    listLabel="Pay Type"
                    listValue="pay_type"
                    list={[{value:'cash',label:'Cash'},{value:'transfer',label:'Transfer'},{value:'none',label:'Not Paid'}]}
                    onChange={handleChange}
                    error={errors["pay_type"] ? true : false}
                    helperText={errors["pay_type"] ? errors.pay_type[0] : null}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-6">
                  <Inputs
                    name="attendant_id"
                    size="small"
                    disabled={isView}
                    inputType="select"
                    value={formValues.attendant_id}
                    defaultValue={{value:1,label:'Test Officer'}}
                    label="Leading Officer"
                    listLabel="Leading Officer"
                    listValue="attendant_id"
                    list={OfficersList}
                    // list={[{value:1,label:'Test Officer'}]}
                    onChange={handleChange}
                    error={errors["attendant_id"] ? true : false}
                    helperText={errors["attendant_id"] ? errors.attendant_id[0] : null}
                  />
                </div>
                
                <div className="col-sm-12 col-md-12 col-12">
                  <Inputs
                    name="remarks"
                    size="small"
                    disabled={isView}
                    label="Other Remarks"
                    value={formValues.remarks}
                    inputType="text"          // keep if your wrapper ignores type when multiline=true
                    multiline={true}                 // <-- make it a textarea
                    minRows={3} 
                    onChange={handleChange}
                    error={!!errors["remarks"]}
                    helperText={errors["remarks"] ? errors.remarks[0] : null}
                  />
                </div>
               
      
              </div>
            </>
          );
        };

        const handleSubmitSchedule = async (e) => {
          e.preventDefault();
          let validationErrors = validate(
            formValues,
            scheduleSchema    
          );
          if(validationErrors){
            setErrors(validationErrors);      
          }else{
            setHideSaveButton(true)
            let schedules = await putVisitSchedule(formValues);
            setHideSaveButton(false)
            if(schedules.data.mode === 'success'){
              toast.success(schedules.data.message ?? "Successful", {
                autoClose: 2600,
                hideProgressBar: true,
              });
            }else{
              toast.error(schedules.data.message ?? "Request has failed", {
                autoClose: 2600,
                hideProgressBar: true,
              });
            }
            setOpenForm(false)
            loadSchedules()
          }
        
        }

        const handleSubmitVisit = async (e) => {
          e.preventDefault();
          let validationErrors = validate(
            visitFormValues,
            visitSchema    
          );
          if(validationErrors){
            setErrors(validationErrors);      
          }else{
            setHideSaveButton(true)
            let schedules = await postVisit(visitFormValues);
            setHideSaveButton(false)
            if(schedules.data.mode === 'success'){
              toast.success(schedules.data.message ?? "Successful", {
                autoClose: 2600,
                hideProgressBar: true,
              });
            }else{
              toast.error(schedules.data.message ?? "Request has failed", {
                autoClose: 2600,
                hideProgressBar: true,
              });
            }
            setOpenForm(false)
            loadSchedules()
          }
        
        }

        const handleRequestClose = () => {
          setErrors([])
          setOpenForm(false);
          setIsView(false);
          setIsVisit(false);
          // setFormValues({})
        };

        const formVisit = (schedule) => {
          return (
            <>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-6">
                  <Inputs
                    name="service_id"
                    size="small"
                    disabled={isView}
                    inputType="select"
                    value={visitFormValues.service_id}
                    defaultValue={{value:0,label:'None'}}
                    label="Service Category"
                    listLabel="Service Category"
                    listValue="service_id"
                    list={[{value:1,label:'Physiotherapy'},{value:2,label:'Home Nursing'}]}
                    onChange={handleChangeVisit}
                    error={errors["service_id"] ? true : false}
                    helperText={errors["service_id"] ? errors.service_id[0] : null}
                  />
                </div>
                <div className="col-sm-12 col-md-6 col-6">
                  <Inputs
                    name="visit_date"
                    size="small"
                    disabled={isView}
                    label="Visit Date"
                    value={visitFormValues.visit_date}
                    inputType="date"
                    onChange={(e) =>
                    handleChange({ target: { name: "visit_date", value: e } })}
                    error={errors["visit_date"] ? true : false}
                    helperText={errors["visit_date"] ? errors.visit_date[0] : null}
                  />
                </div>
                
                <div className="col-sm-12 col-md-12 col-12">
                  <Inputs
                    name="remarks"
                    size="small"
                    disabled={isView}
                    label="Other Remarks"
                    value={visitFormValues.remarks}
                    inputType="text"          // keep if your wrapper ignores type when multiline=true
                    multiline={true}                 // <-- make it a textarea
                    minRows={3} 
                    onChange={handleChangeVisit}
                    error={!!errors["remarks"]}
                    helperText={errors["remarks"] ? errors.remarks[0] : null}
                  />
                </div>
               
      
              </div>
            </>
          );
        };


      return (
        <>
        <div className="row">
        <div className="col-12">
          <h2>Pending Visit Schedules</h2>
          <br/>
        </div>
        <div className="col-12">
          <div className="card" style={{ backgroundColor: "#e0e0e0" }}>
            <div className="card-body">
              {isLoading === false ? (
                <Table
                  columns={tableHead}
                  data={schedulesList}
                  actions={[
                    {
                      action: "Details",
                    //   renderCheck: isDetailsAccess,
                      onClick: (item) => {
                        viewItem(item);
                      },
                    },
                    {
                      action: "Edit",
                    //   renderCheck: isDetailsAccess,
                      onClick: (item) => {
                        editItem(item);
                      },
                    },
                    {
                      action: "Mark Visit",
                    //   renderCheck: isDetailsAccess,
                      onClick: (item) => {
                        markVisit(item);
                      },
                    },
                    
                  ]}
                  downloadFileName={"Registered Schedules"}
                />
              ) : (
                <MySpinner size={35} color="#367588" />
              )}
            </div>
          </div>
        </div>
        <MyDialog
                title={"Visit Schedule for "+String(selectedItem?.customer_name).toUpperCase()+" "+selectedItem?.customer_mobile}
                width="sm"
                onClose={handleRequestClose}
                open={openForm && !isVisit}
                text={"Save"}
                content={() =>
                  formVisitSchedule(selectedItem && selectedItem.id ? selectedItem : null)
                }
                submit={async (e) => await handleSubmitSchedule(e)}
                hideSaveButton={hideSaveButton}
                propBackgroundColor={"#367588"}
              />

<MyDialog
                title={"Visit for "+String(selectedItem?.customer_name).toUpperCase()+" "+selectedItem?.customer_mobile}
                width="sm"
                onClose={handleRequestClose}
                open={openForm && isVisit}
                text={"Save"}
                content={() =>
                  formVisit(selectedItem && selectedItem.id ? selectedItem : null)
                }
                submit={async (e) => await handleSubmitVisit(e)}
                hideSaveButton={hideSaveButton}
                propBackgroundColor={"#367588"}
              />
      </div>
        </>
      )


}
export default Schedules;